
import {UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { BesoinBlocFormData } from '../../../blocs/retirement/REBesoinBloc';
import { useState } from 'react';
import { budgetLevelOptions, nonRefungdingPaymentLevelOptions } from '../../../const/AppConst';

type BesoinInfoFormComponentProps = {
    setValue: UseFormSetValue<BesoinBlocFormData>,
    getValues: UseFormGetValues<BesoinBlocFormData>
}

export default function CoverLevelFormComponent({ setValue, getValues} : Readonly<BesoinInfoFormComponentProps>) {
    const [refundingValue, setRefundingValue] = useState(getValues('coveragesInfo.nonRefundingPayment') );
    const [budgetValue, setBudgetValue] = useState(getValues('coveragesInfo.budget') );
    const width =window.innerWidth ;
    let optionsStyle:string = "flex text value-section va-center"

    if(width>1500){
        optionsStyle +=''
    } else if(width>1320){
          optionsStyle += " value-section-sm-screen"
    }
    else if (width>750){
          optionsStyle += " value-section-xs-screen"
    } 
    else{
          optionsStyle += " value-section-mobile"
    }

    const handleNonRefundingPaymentOnClick = (e: any, level: number) => {
        e.preventDefault();
        setRefundingValue(level);
        setValue('coveragesInfo.nonRefundingPayment', level)   
    }

    const handleBudgetOnClick = (e: any, level: number) => {
        e.preventDefault();
        setBudgetValue(level);
        setValue('coveragesInfo.budget', level)   
    }

    return (             
        <>
            <h2 className='card-title bleu'>Niveau de couverture santé souhaité</h2>
            <p className='text mt-xs mb-lg fz-sm'>
                Veuillez indiquer le niveau de couverture souhaité.
            </p>
            
            <div className="coverCard">
                <p className="bleu fz-sm fw-medium mb-lg"> A quel niveau estimez-vous vos dépenses de santé / les dépenses de santé de votre famille non remboursées par la sécurité sociale?</p>
                <div  className={`${optionsStyle}`} 
                >
                    {nonRefungdingPaymentLevelOptions.map(button => <button  
                        key={button?.level}   
                        className={refundingValue === button.level ? 
                            "value-button fz-sm value-selected" :
                            "value-button fz-sm"} 
                        onClick={(e) => handleNonRefundingPaymentOnClick(e, button?.level)}
                        
                        >
                            {button?.label}
                    </button>)}
                    
                </div>
                </div>
                <div className="coverCard mt-lg">
                <p className="bleu fz-sm fw-medium mb-lg">Quel budget êtes-vous prêt à consacrer à votre couverture complémentaire santé ?</p>
                <div  className={`${optionsStyle} ` }
                >
                    {budgetLevelOptions.map(button => <button  
                        key={button?.level}   
                        className={budgetValue === button.level ? "value-button fz-sm value-selected" 
                                                                : "value-button fz-sm"} 
                        onClick={(e) => handleBudgetOnClick(e, button?.level)}
                        
                        >
                            {button?.label}
                    </button>)}                   
                </div>
            </div>
 
        </>         
  )
}
